import request from './request'

/**
 * 意见反馈分页查询
 * @param {Object} data - { pageNum, pageSize }
 * @returns {Promise} data 为 { total, rows }，rows 每行：
 *   {
 *     id: 113,                    // 反馈记录 id
 *     feedbackContent: '这是反馈111', // 反馈内容
 *     feedbackStatus: 'pending',  // 反馈状态：pending=待回复，reply=已回复
 *     feedbackReply: null         // 官方回复内容，未回复时为 null
 *   }
 */
export function getFeedbackPage(data) {
  return request({
    url: '/help/feedback/page',
    method: 'post',
    data
  })
}

/**
 * 新增意见反馈
 * @param {Object} data - { feedbackContent } 反馈内容
 * @returns {Promise} data 为 true 表示提交成功
 */
export function createFeedback(data) {
  return request({
    url: '/help/feedback/create',
    method: 'post',
    data
  })
}
